export default function socialShare({ main, on, elm }) {
  const shareUrl = elm.dataset.shareUrl || window.location.href;
  const shareTitle = elm.dataset.shareTitle || document.title;
  const shareText = elm.dataset.shareText || '';
  const shareSuccessText = elm.dataset.shareSuccessText || '';
  const shareErrorText = elm.dataset.shareErrorText || '';
  const liveRegion = elm.querySelector('[data-share-status]');

  main(() => {
    on('click', '[data-share-popup]', handlePopupShare);
    on('click', '[data-share-instagram]', handleInstagramShare);
    on('click', '[data-share-native]', handleNativeShare);
  });

  function handlePopupShare(event) {
    const link = event.target.closest('[data-share-popup]');

    if (!link) return;

    event.preventDefault();

    const href = link.getAttribute('href');

    if (!href) return;

    const width = 680;
    const height = 540;
    const left = Math.max(0, Math.round(window.screenX + (window.outerWidth - width) / 2));
    const top = Math.max(0, Math.round(window.screenY + (window.outerHeight - height) / 2));
    const features = `popup=yes,width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`;
    const popup = window.open(href, '_blank', features);

    if (popup) {
      popup.focus();
    } else {
      window.location.href = href;
    }
  }

  async function handleNativeShare(event) {
    const trigger = event.target.closest('[data-share-native]');

    if (!trigger) return;

    event.preventDefault();

    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        });

        return;
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }
      }
    }

    await copyToClipboard();
  }

  async function handleInstagramShare(event) {
    const trigger = event.target.closest('[data-share-instagram]');

    if (!trigger) return;

    event.preventDefault();

    await shareOrCopy();
  }

  async function shareOrCopy() {
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        });

        return;
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }
      }
    }

    await copyToClipboard();
  }

  async function copyToClipboard() {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        fallbackCopyTextToClipboard(shareUrl);
      }

      announce(shareSuccessText);
    } catch (error) {
      announce(shareErrorText);
    }
  }

  function fallbackCopyTextToClipboard(text) {
    const textarea = document.createElement('textarea');

    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';

    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);
    document.execCommand('copy');
    textarea.remove();
  }

  function announce(message) {
    if (!liveRegion || !message) return;

    liveRegion.textContent = '';

    requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
  }
}
